import React from 'react';
import { Link } from 'react-router-dom';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { permanences, TODAY } from '../../data/store';
import { getCreator } from '../../utils/catalog';
import { formatDate } from '../../utils/exhibition';
export function PermanenceWeek() {
  return <ul className="divide-y divide-line border-y border-line" data-id="element-342" data-mp="1al31x6p56daa">
      {permanences.map(p => {
      const isToday = differenceInCalendarDays(parseISO(p.date), TODAY) === 0;
      return <li key={p.date} className="grid grid-cols-[92px_1fr] items-baseline gap-4 py-3.5" data-id="element-343" data-mp="1jnkltehbqtu4">
            <span className={`text-sm capitalize ${isToday ? 'font-medium text-clay' : 'text-muted'}`} data-id="element-344" data-mp="1ybyrdx64kwed">
              {isToday ? 'Aujourd’hui' : formatDate(p.date, 'EEE d MMM')}
            </span>
            <span className="text-sm" data-id="element-345" data-mp="27bltkl6oi68h">
              {p.creatorIds.map((id, i) => {
            const c = getCreator(id);
            if (!c) return null;
            return <React.Fragment key={id} data-id="element-346" data-mp="250dnioqfl7eb" data-mpi={i}>
                    <Link to={`/createurs/${id}`} className="hover:text-clay" data-id="element-347" data-mp="251ot8u3fsp82">
                      {c.maker}
                    </Link>
                    <span className="text-muted" data-id="element-348" data-mp="2e0trdzb36gjp"> ({c.name})</span>
                    {i < p.creatorIds.length - 1 && <span className="text-muted" data-id="element-349" data-mp="2izdew45bw0e6"> · </span>}
                  </React.Fragment>;
          })}
            </span>
          </li>;
    })}
    </ul>;
}